export default __webpack_public_path__ + "static/media/bath.c8e443ed.svg";